import { useState, type ReactNode } from "react";
import { ChevronDown } from "lucide-react";

interface SectionCardProps {
  header?: ReactNode;
  children: ReactNode;
  collapsible?: boolean;
  defaultCollapsed?: boolean;
  className?: string;
}

export function SectionCard({
  header,
  children,
  collapsible = true,
  defaultCollapsed = false,
  className,
}: SectionCardProps) {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  return (
    <section className={`wizard-card section-card section-card-elevated flex flex-col gap-6${className ? ` ${className}` : ""}`}>
      {collapsible ? (
        <button
          type="button"
          className="flex w-full items-start justify-between gap-4 text-left"
          onClick={() => setCollapsed((c) => !c)}
          aria-expanded={!collapsed}
        >
          <div className="min-w-0 flex-1">{header}</div>
          <ChevronDown
            className={`mt-1 size-5 shrink-0 text-slate-400 transition-transform duration-200 ${collapsed ? "-rotate-90" : "rotate-0"}`}
          />
        </button>
      ) : (
        header
      )}

      {(!collapsible || !collapsed) && (
        <div className="flex flex-col gap-6">{children}</div>
      )}
    </section>
  );
}
